// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__1r77b","select":"style_select__LExLJ","rp":"style_rp__2ygQP","toPrint":"style_toPrint__285cx"};